import { render, staticRenderFns } from "./ForumOutline.vue?vue&type=template&id=31c9fdd9&"
import script from "./ForumOutline.vue?vue&type=script&lang=js&"
export * from "./ForumOutline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports